import axios from 'axios'
const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 5000
})

export function login(data) {
    return axiosInstance({
        method: 'post',
        url:'auth/oauth/token',
        params: data,
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic anJjOjEyMzQ1Ng=='
        }
    })
}
export function logout(data) {
    return axiosInstance({
        url: '/auth/logout',
        method: 'post',
        data,
        headers:{
            'Authorization': 'Basic anJjOjEyMzQ1Ng=='
        }
    })
}
export function updatePass(data) {
    return axiosInstance({
        url: '/user/SysUserWsg/updatePassword?',
        method: 'post',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
export function getMenus(data) {
    return axiosInstance({
        method: 'get',
        url:'/user/sysGroup/getCanFunction',
        headers:{
            'Authorization': 'Bearer '+data
        }
    })
}

export function checkPassword(password){
    return axiosInstance({
        method: 'get',
        url:'/user/api/password/check',
        params: {password:password},
    })
}


export function getCode() {
    return axiosInstance({
        method: 'get',
        url:'/code',
    })
}


